import { render, staticRenderFns } from "./theme-dark.vue?vue&type=template&id=075c2790&"
import script from "./theme-dark.vue?vue&type=script&lang=js&"
export * from "./theme-dark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports